const BigScreenBdmin = () => import('@/components/BigScreen_admin')
const BigScreenJrjg = () => import('@/components/BigScreen_jrjg')
const BigScreenZfjg = () => import('@/components/BigScreen_zfjg')
const BigScreenQy = () => import('@/components/BigScreen_qy')
const ViewQyStatics = () => import('@/components/BigScreenComponents/admin/ViewQyStatics')

const ViewLcycStatics = () => import('@/components/BigScreenComponents/lcyc/ViewLcycStatics')

export default [
  {
    path: '/bigdata/admin',
    name: 'BigScreenBdmin',
    component: BigScreenBdmin,
    meta: {
      title: '管理员dashboard',
    },
  },
  {
    path: '/bigdata/jrjg',
    name: 'BigScreenJrjg',
    component: BigScreenJrjg,
    meta: {
      title: '金融机构dashboard',
    },
  },
  {
    path: '/bigdata/zfjg',
    name: 'BigScreenZfjg',
    component: BigScreenZfjg,
    meta: {
      title: '政府机构dashboard',
    },
  },
  {
    path: '/bigdata/qy',
    name: 'BigScreenQy',
    component: BigScreenQy,
    meta: {
      title: '企业dashboard',
    },
  },
  {
    path: '/bigdata/qyStatics',
    name: 'ViewQyStatics',
    component: ViewQyStatics,
    meta: {
      title: '企业数据统计'
    }
  },
  {
    path: '/bigdata/lcycStatics',
    name: 'ViewLcycStatics',
    component: ViewLcycStatics,
    meta: {
      title: '人才数据统计'
    }
  }

]
